const serviceLinks = [
  "Solar Installation",
  "Battery Storage",
  "EV Charger Installation",
  "Electrical Services",
  "Solar Repair & Maintenance",
  "Emergency Electrical",
];

const areaLinks = ["Pleasant Hill", "Walnut Creek", "Lafayette", "Concord", "Martinez", "Orinda"];

export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-white text-gray-800 border-t border-gray-100">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="mb-4">
              <img
                src="https://storage.readdy-site.link/project_files/02ee9be7-bc98-43d6-99e9-93e5834dd697/c425a6fa-6b0b-4d61-a5d6-5d19dc333234_wired-logo.jpg"
                alt="Wired Into The Future Logo"
                className="h-14 w-auto object-contain"
              />
            </div>
            <p className="text-gray-500 text-sm leading-relaxed mb-5">
              Premium solar installation, battery storage, EV charging, and electrical services for the East Bay Area. 21+ years of trusted expertise.
            </p>
            <div className="flex items-center gap-3">
              <a href="tel:9258723408" className="flex items-center gap-2 text-amber-400 font-semibold text-sm hover:text-amber-300 transition-colors">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-fill"></i>
                </div>
                (925) 872-3408
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-sm font-bold text-gray-900 uppercase tracking-wider mb-4">
              <a href="#services" onClick={(e) => { e.preventDefault(); scrollTo("#services"); }}>Services</a>
            </h4>
            <ul className="space-y-2.5">
              {serviceLinks.map((s) => (
                <li key={s}>
                  <a
                    href="#services"
                    onClick={(e) => { e.preventDefault(); scrollTo("#services"); }}
                    className="text-gray-500 hover:text-amber-500 text-sm transition-colors cursor-pointer"
                    rel="nofollow"
                  >
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h4 className="text-sm font-bold text-gray-900 uppercase tracking-wider mb-4">Service Areas</h4>
            <ul className="space-y-2.5">
              {areaLinks.map((a) => (
                <li key={a}>
                  <span className="text-gray-500 text-sm">{a}, CA</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-bold text-gray-900 uppercase tracking-wider mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2.5">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-phone-line text-amber-500 text-sm"></i>
                </div>
                <a href="tel:9258723408" className="text-gray-500 hover:text-amber-500 text-sm transition-colors">(925) 872-3408</a>
              </li>
              <li className="flex items-start gap-2.5">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-line text-amber-500 text-sm"></i>
                </div>
                <span className="text-gray-500 text-sm">Pleasant Hill, CA<br />East Bay Area</span>
              </li>
              <li className="flex items-start gap-2.5">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-time-line text-amber-500 text-sm"></i>
                </div>
                <span className="text-gray-500 text-sm">Mon–Fri: 8am–6pm<br />Emergency: 24/7</span>
              </li>
            </ul>

            <button
              onClick={() => scrollTo("#contact")}
              className="mt-6 w-full bg-amber-500 hover:bg-amber-600 text-white text-sm font-semibold py-2.5 rounded-md transition-colors cursor-pointer whitespace-nowrap"
            >
              Get a Free Quote
            </button>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-gray-400 text-xs">
            &copy; {new Date().getFullYear()} Wired Into The Future Inc. All rights reserved.
          </p>
          <p className="text-gray-400 text-xs">
            Serving: <strong className="text-gray-600">Pleasant Hill</strong> · <strong className="text-gray-600">Walnut Creek</strong> · <strong className="text-gray-600">Lafayette</strong> · East Bay, CA
          </p>
        </div>
      </div>
    </footer>
  );
}
